import { Component, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { PerfilService } from 'src/app/services/PerfilService/perfil.service';
import { generateUUID } from 'src/app/core/generators/generateUUID';

@Component({
  selector: 'app-modal-cadastrar-perfil',
  templateUrl: './modal-cadastrar-perfil.component.html',
  styleUrls: ['./modal-cadastrar-perfil.component.scss']
})
export class ModalCadastrarPerfilComponent implements OnInit {
  form: FormGroup;
  isEditing: boolean = false;
  isLoading: boolean = false;
  guid: string = generateUUID();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private perfilService: PerfilService,
    public dialogRef: MatDialogRef<ModalCadastrarPerfilComponent>,
    public dialog: MatDialog
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    if (this.data.editing) {
      this.isEditing = true;
    }
  }

  initForm() {
    const form = this.fb.group({
      NM_PERF: this.fb.control('', {
        validators: [Validators.required]
      })
    });
    return form;
  }

  onConfirmar(): void {
    if (!this.isEditing) {
      this.postCadastrarPerfil();
    }
    if (this.isEditing) {
      this.putEditarPerfil();
    }
  }

  postCadastrarPerfil() {
    this.isLoading = true;
    const { NM_PERF } = this.form.value;
    this.perfilService.CreatePerfil(NM_PERF, this.guid).subscribe({
      next: response => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: error => {
        this.isLoading = false;
      }
    });
  }

  putEditarPerfil() {
    this.isLoading = true;
    const { NM_PERF } = this.form.value;
    const id = this.data.id;
    this.perfilService.UpdatePerfil(id, NM_PERF).subscribe({
      next: response => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: error => {
        this.isLoading = false;
      }
    });
  }

  onCancelar(): void {
    this.dialogRef.close();
  }
}
